'use strict';

angular.module('breakmarkApp').controller('storeProductsTableEditProductModal', function ($scope, $rootScope, $Products, $q, Upload, $timeout, $uibModalInstance, product, store) {

    const storage = firebase.storage();
    const storageRef = storage.ref();

    $scope.init = function() {

        $scope.product = product;

        console.log('storeProductsTableEditProductModal', store );

    };

    $scope.init();

    $scope.close = function() {

        $uibModalInstance.dismiss('cancel');

    };

    // scope.fileUploadProgress = 0;
    $scope.uploadingImage = false;

    //console.log('scope product', scope.product);

    $scope.submit = function() {

        store.$save().then(() => {
            $uibModalInstance.close(store);
        });
    };

    $scope.makeImageFeatured = function(featuredImage) {

        // console.log('featured image', featuredImage);

        _.forEach($scope.product.images, function(image) {

            // console.log('image', image);

            if(image.productImageRef === featuredImage.productImageRef){

                image.featured = true;

            } else {

                // console.log('setting this to false');

                image.featured = false;

            }

        });

        $scope.product.featuredImage = featuredImage;

        $scope.$apply();

        // store.$save();

    };

    $scope.deleteAllImages = function() {

        _.forEach($scope.product.images, function(image) {

            $scope.deleteImage(image);

        });

        $scope.product.images = null;

    };

    $scope.deleteImage = function(imageToDelete) {

        console.log('image to delete', imageToDelete);

        let deleteImageRef = storageRef.child(imageToDelete.productImageRef);

        console.log('ref to delete', deleteImageRef);

        deleteImageRef.delete().then(function() {

            console.log('before removing', $scope.product.images.length);

            $scope.product.images = _.reject($scope.product.images, { 'productImageRef': imageToDelete.productImageRef});
            console.log('file ref deleted');

            console.log('after removing',$scope.product.images.length);

            $scope.$apply();

             store.$save().then(function() {
                alert('deleted image');
            });
            // File deleted successfully
        }).catch(function(error) {
            // Uh-oh, an error occurred!
            console.log('ERROR', error);

            if(error.code === 'storage/object-not-found'){

                // it appears as though our error is a 404, let's just remove the image ref just for fun and profit

                $scope.product.images = _.reject($scope.product.images, { 'productImageRef': imageToDelete.productImageRef});
                console.log('file ref deleted after error');

                // store.$save();

            }
        });

    };

    $scope.uploadFiles = function (files) {

        $scope.files = files;

        $scope.uploadingImage = true;

        // TODO: Add a check here to see if we have a file by that name already

        if(!$scope.product.images){
            $scope.product.images = [];
        }

        if (files && files.length) {

            _.forEach(files, function(file) {

               var uploadImageTask = storageRef.child('stores/' + store.$id + '/products/' + $scope.product.id + '/' + file.name).put(file);

               uploadImageTask.on('state_changed', function(snapshot){
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                   $scope.fileUploadProgress = Math.floor( (snapshot.bytesTransferred / snapshot.totalBytes) * 100 );

                //    scope.uploadingMessage = 'Upload is ' + scope.fileUploadProgress + '% done';

                   $scope.$apply();

                   console.log('Upload is ' + $scope.fileUploadProgress + '% done');

                   switch (snapshot.state) {
                     case firebase.storage.TaskState.PAUSED: // or 'paused'
                       console.log('Upload is paused');
                       break;
                     case firebase.storage.TaskState.RUNNING: // or 'running'
                       console.log('Upload is running');
                       break;
                   }
                }, function(error) {
                    // Handle unsuccessful uploads
                    switch (error.code) {
                      case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;

                      case 'storage/canceled':
                        // User canceled the upload
                        break;

                      case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                    }
                }, function() {
                    // Handle successful uploads on complete
                    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                    //
                    $scope.uploadingImage = false;

                    $scope.product.images.push({
                        productImageRef: uploadImageTask.snapshot.ref.fullPath,
                        productImage: uploadImageTask.snapshot.downloadURL
                    });

                    if($scope.product.images.length === 1){

                        $scope.makeImageFeatured($scope.product.images[0]);

                    }

                    $scope.$apply();

                    // console.log('lot tot tot lot', store);


                    // store.$save().then( (returnedStore) => {
                    //     console.log('lot tot tot lot', returnedStore);
                    // });

                });

            });

            // $timeout( () => {
            //
            //     let haystackProduct = _.find(store.products, {id: product.id});
            //
            //     console.log('haystackProduct', haystackProduct);
            //
            //     store.$save().then(() => {
            //
            //         // alert('saving store after uploading image');
            //
            //         console.log('product', $scope.product.images);
            //     });
            //
            // }, 250)

        }

    };

    $scope.uploadFitGuide = function (fitGuide) {

        $scope.fitGuide = fitGuide;

        $scope.uploadingFitGuide = true;

        // TODO: Add a check here to see if we have a file by that name already

        if (fitGuide && fitGuide.length) {

            _.forEach(fitGuide, function(file) {

               var uploadFitGuideTask = storageRef.child( 'stores/' + store.$id + '/products/' + $scope.product.id + '/' + file.name).put(file);

               uploadFitGuideTask.on('state_changed', function(snapshot){
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded

                }, function(error) {
                    // Handle unsuccessful uploads
                    switch (error.code) {
                      case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;

                      case 'storage/canceled':
                        // User canceled the upload
                        break;

                      case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                    }
                }, function() {
                    // Handle successful uploads on complete
                    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                    $scope.product.fitGuide = {
                        fileRef: uploadFitGuideTask.snapshot.ref.fullPath,
                        file: uploadFitGuideTask.snapshot.downloadURL
                    };

                    $scope.uploadingFitGuide = false;

                    // store.$save();

                });

            });
        }

    };

    $scope.removeFitGuide = function(fitGuideToDelete) {

        console.log('fitGuideToDelete to delete', fitGuideToDelete);

        let deleteFitGuideRef = storageRef.child(fitGuideToDelete.fitGuide.fileRef);

        deleteFitGuideRef.delete().then(function() {

            $scope.product.fitGuide = null;

            // store.$save();
            // File deleted successfully
        }).catch(function(error) {
            // Uh-oh, an error occurred!
            console.log('ERROR', error);

            if(error.code === 'storage/object-not-found'){

                // it appears as though our error is a 404, let's just remove the image ref just for fun and profit

                $scope.product.fitGuide = null;
                console.log('file ref deleted after error');

                // store.$save();

            }
        });

    }

});
